
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Detail extends Vue {
  private activeName = 'base'
  projectId = ''

  created () {
    this.activeName = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
    this.projectId = this.$route.query.projectId as string
  }

  handleClick () {
    const path = `/projectList/detail/${this.activeName}?projectId=${this.projectId}`
    if (path !== this.$route.path) {
      this.$router.replace({ path: path })
    }
  }
}
